import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormGroupDirective,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import {
  MatTableDataSource,
  MatSort,
  Sort,
  ErrorStateMatcher
} from '@angular/material';
import {
  RoleService,
  UserService,
  LoadingService,
  MenuService
} from '../../_shared/services';
import {
  APIResponse,
  Role,
  BluePrintRole,
  Division,
  Menu,
  Pagination,
  User,
  regExps,
  MyErrorStateMatcher,
  errorMessages
} from '../../_shared';

import { Granule } from '../../config';

@Component({
  selector: 'app-user-level',
  templateUrl: './user-level.component.html',
  styleUrls: [
	'./user-level.component.css',
	 '../_css/user-management.component.css',
    '../../../assets/css/core-navbar.css',
    '../_css/user-management-list.component.css',
    '../_css/user-management-mobile-responsive.css'
  ]
})
export class UserLevelComponent implements OnInit {
  private categories: any;
  private data: any;
  private limit: Array<number> = [10, 10];
  private selectedPage: number = 1;
  private toggleDropdown: Array<boolean> = new Array<boolean>(4);
  /**
   * 0 = items per page in user level page
   * 1 = items per page in user level page
   * 2 = division in edit member modal
   * 3 = -
   */
  private storageProfileUrl = this.granule.CMS_ROUTE_STORAGE_USER;
  private menus: Menu[];
  private roles: Role[];
  private rolesDisplayed: Role[];
  private isEnabledToggled: boolean;
  private permissionsForm: Array<string> = new Array<string>();
  private selectedRole: Role;
  private members: User[];
  private membersDisplayed: User[];
  private memberList: User[];
  private selectedDivision = 'All Division';
  private divisions = new Array<Division>();
  private newUserLevelForm: FormGroup;
  private editUserLevelForm: FormGroup;
  private errorMatcher = new MyErrorStateMatcher();
  private errors = errorMessages;
  private searchKey: string;

  constructor(
    private roleService: RoleService,
    private userService: UserService,
    private loadingService: LoadingService,
    private menuService: MenuService,
    private granule: Granule,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.initForms();
    this.getAllMenu();
    this.initDivision();
    this.initRole();
    this.initToggleDropdown();
    this.load(false);
  }

  initDivision() {
    this.userService.getDivision().subscribe((res: APIResponse<any, any>) => {
      this.divisions = res.data;
    });
  }

  initRole() {
    this.roleService.getRoles().subscribe(
      res => {
        this.roles = res.data;
        this.rolesDisplayed = res.data;
      },
      x => { },
      () => {
        // this.load(false);
      }
    );
  }

  initForms() {
    // constructor + form Validator for New User Level
    this.newUserLevelForm = this.fb.group({
      nameControl: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20)
        ])
      ]
    });
    // constructor + form Validator for Edit User Level
    this.editUserLevelForm = this.fb.group({
      nameControl: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20)
        ])
      ]
    });
  }

  initToggleDropdown() {
    // init the dropdown for the first time, and also closes the dropdown if called
    for (let i in this.toggleDropdown) {
      this.toggleDropdown[parseInt(i)] = false;
    }
  }

  initModal() {
    this.newUserLevelForm.reset();
    this.editUserLevelForm.reset();
    this.permissionsForm = new Array<string>();
  }

  filterDivision(division: Division) {
    this.changeDivisionDisplayed(division.name);

    // do filter here
  }

  changeDivisionDisplayed(name: string) {
    this.selectedDivision = name;

    if (name === 'All Division') {
      this.membersDisplayed = this.members;
    }
  }

  addMenu(menu: any, parent_index: number = 0) {
    let index = this.permissionsForm.indexOf(menu._id);
    if (index > -1) {
      this.permissionsForm.splice(index, 1);

      parent_index = -1;
    } else {
      if (parent_index > -1) {
        this.permissionsForm.push(menu._id);
      }
    }
    if (menu.menu_child.length > 0) {
      for (let menu_item of menu.menu_child) {
        this.addMenu(menu_item, parent_index);
      }
    }
  }

  selectRole(role: Role) {
    this.selectedRole = role;
    this.showMembers();
  }

  showMembers() {
    this.members = this.selectedRole.members;
    this.membersDisplayed = this.members;
  }

  showNonMembers() {
    this.members = this.selectedRole.non_members;
    this.membersDisplayed = this.members;
  }

  addMembers() { }

  removeMembers() { }

  addUserLevel() {
    this.load(true);
    const formModel = this.newUserLevelForm.value;

    let userLevel: BluePrintRole = {
      name: formModel.nameControl,
      display_name: formModel.nameControl,
      status: 'enable',
      has_menu: this.permissionsForm
    };

    this.roleService.addRole(userLevel).subscribe(
      res => {
        // this.registerFormErrorMessages = res.errors;
        // this.submitSuccess = res.success;
      },
      () => { },
      () => {
        this.initRole();
        this.permissionsForm = [];
        this.load(false);
        // if (this.submitSuccess === true) {
        //   this.registerForm.reset();
        //   this.message = 'Successfully Create New Account';
        //   $('#submitNotification').modal('show');
        // } else {
        //   console.log(this.registerFormErrorMessages);
        // }
      }
    );
  }

  editUserLevel() {
    this.load(true);
    const formModel = this.editUserLevelForm.value;

    let status = '';
    if (this.isEnabledToggled) {
      status = 'enabled';
    } else {
      status = 'disabled';
    }

    let userLevel: Role = {
      _id: this.selectedRole._id,
      name: formModel.nameControl,
      display_name: formModel.nameControl,
      status: status,
      has_menu: this.permissionsForm,
      members: null,
      non_members: null,
      // this ^^^
      count: null,
      created_at: null,
      updated_at: null
    };

    this.roleService.editRole(userLevel).subscribe(
      res => {
        // this.registerFormErrorMessages = res.errors;
        // this.submitSuccess = res.success;
      },
      () => { },
      () => {
        this.initRole();
        this.permissionsForm = [];
        this.load(false);
        // if (this.submitSuccess === true) {
        //   this.registerForm.reset();
        //   this.message = 'Successfully Create New Account';
        //   $('#submitNotification').modal('show');
        // } else {
        //   console.log(this.registerFormErrorMessages);
        // }
      }
    );
  }

  deleteUserLevel() {
    let payload = JSON.stringify(this.selectedRole._id);
    this.roleService.deleteRole(payload).subscribe(
      res => {
        console.log(res);
      },
      () => { },
      () => {
        this.initRole();
      }
    );
  }

  getAllMenu() {
    let data = {
      type: 'all'
    };
    this.menuService.getMenu(data).then(res => {
      this.menus = res.data;
    });
  }

  isChecked(menu: any) {
    let index = this.permissionsForm.indexOf(menu._id);

    // if in edit user level form
    this.editUserLevelForm.markAsDirty();

    if (index > -1) {
      // if doesn't have menuus child checked, uncheck parent menu
      if (menu.menu_child.length > 0) {
        let menuChildCount = 0;
        for (let item of menu.menu_child) {
          if (this.permissionsForm.indexOf(item._id) > -1) {
            menuChildCount++;
          }
        }

        if (menuChildCount == 0) {
          // removes from list
          this.addMenu(menu);
          return false;
        }
      }

      // menu checked
      return true;
    } else {
      return false;
    }
  }

  changeLimit(value: number, index: number) {
    this.limit[index] = value;
  }

  changePage(value: number) {
    this.selectedPage = value;
  }

  dropdownControl(value: number) {
    for (let i = 0; i < 4; i++) {
      if (i === value) {
        // if the array number match with value from function, reverse the bool value to toggle
        this.toggleDropdown[i] = !this.toggleDropdown[i];
      } else {
        // other than that, set to false to close dropdown
        this.toggleDropdown[i] = false;
      }
    }
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  selectUserLevel(role: any) {
    this.selectedRole = role;
  }

  searchUserLevel() {
    if (this.searchKey === '') {
      this.rolesDisplayed = this.roles;
    } else {
      let search = this.searchKey.toLowerCase();
      this.rolesDisplayed = this.roles.filter(
        r =>
          r.name.toLowerCase().includes(search) ||
          r.status.toLowerCase().includes(search) ||
          r.created_at.toString().includes(search) ||
          r.updated_at.toString().includes(search)
      );
    }
  }

  sortData(sort: Sort) {
    const data = this.roles.slice();
    if (!sort.active || sort.direction == '') {
      this.roles = data;
      return;
    }

    this.roles = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'userLevel':
          return this.compare(
            a.name.toLowerCase(),
            b.name.toLowerCase(),
            isAsc
          );
        case 'member':
          return this.compare(a.count, b.count, isAsc);
        case 'status':
          return this.compare(
            a.status.toLowerCase(),
            b.status.toLowerCase(),
            isAsc
          );
        case 'createdOn':
          return this.compare(a.created_at, b.created_at, isAsc);
        case 'lastModified':
          return this.compare(a.updated_at, b.updated_at, isAsc);
        default:
          return 0;
      }
    });
  }

  compare(a: any, b: any, isAsc: any) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  changeStatus(value: any) {
    this.selectedRole.status = value;
  }

  toggleStatus() {
    this.isEnabledToggled = !this.isEnabledToggled;
    this.editUserLevelForm.markAsDirty();
  }

  populateEditUserLevelForm(selectedRole: Role) {
    this.selectedRole = selectedRole;
    this.editUserLevelForm.reset({
      nameControl: selectedRole.name
    });
    if (selectedRole.status == 'enabled') {
      this.isEnabledToggled = true;
    } else {
      this.isEnabledToggled = false;
    }
    this._populateMenuSelection(selectedRole);
  }

  _populateMenuSelection(selectedRole: Role) {
    this.permissionsForm = [];
    for (let menu of selectedRole.has_menu) {
      this.permissionsForm.push(menu);
      this.isChecked(menu);
    }
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/user-management/user-level/user-level.component.ts